import * as React from 'react'
import './styles.scss'

interface ModalBodyMainProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

function ModalBodyMain({ children, ...rest }: ModalBodyMainProps) {
  return (
    <div className="modal-body-main">
      <div {...rest}>{children}</div>
    </div>
  )
}

function ModalBodyActions({ children }: { children: React.ReactNode }) {
  return <div className="modal-body-actions">{children}</div>
}

export function ModalBody({ children }: { children: React.ReactNode }) {
  return <div className="modal-body">{children}</div>
}

ModalBody.main = ModalBodyMain
ModalBody.actions = ModalBodyActions
